import type { IconName } from '@/components/entities/Sprite/Icon';

type SocialMediaLink = {
  label: string;
  href: string;
  icon: IconName;
};

export const SOCIAL_MEDIA_LINKS: SocialMediaLink[] = [
  {
    label: 'facebook',
    href: 'https://www.facebook.com/people/SweepKing-Social-Casino/61576742952563/',
    icon: 'facebook',
  },
  {
    label: 'instagram',
    href: 'https://www.instagram.com/sweepking_official/',
    icon: 'instagram',
  },
  {
    label: 'twitter',
    href: 'https://x.com/SweepKingCasino',
    icon: 'twitter',
  },
  {
    label: 'youtube',
    href: 'https://www.youtube.com/@SweepKingCasino',
    icon: 'youtube',
  },

];
